import React from 'react';
import PropTypes from 'prop-types';

export const alertTypes = {
  primary: "amira-alert-primary",
};

export class Alert extends React.Component {
  render() {
    const {type = alertTypes.primary} = this.props;
    const classes = `amira-alert-container ${type}`;
    return (
      <div className={classes}>
        <div className="amira-alert-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

Alert.propTypes = {
  type: PropTypes.string,
}
